import React from 'react';

import { useTranslation } from 'react-i18next';
import LoginLayout from '../components/LoginLayout';
import LoginCard from '../components/LoginCard';
import Heading from '../../../generic-components/Heading';
import { TIMER_SCREEN_DATA } from '../constants';

const Take5 = () => {
  const { LOGIN_CARD, HEADING, TEXT } = TIMER_SCREEN_DATA;
  const { t } = useTranslation();
  return (
    <LoginLayout backButton backDestination={0}>
      <LoginCard className={LOGIN_CARD.CLASS_NAME} backgroundColor={LOGIN_CARD.BACKGROUND}>
        <Heading title={t(HEADING.TITLE)} className={HEADING.CLASS_NAME} />
        <Heading
          title={t(TEXT.TITLE_ROW_1)}
          className={TEXT.CLASS_NAME}
        />
      </LoginCard>
    </LoginLayout>
  );
};

export default Take5;
